// @ts-nocheck

import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
  uploadString,
} from 'firebase/storage'
import mime from 'mime'
import path from 'path'
import { useState } from 'react'

import { PickFile } from '@/core/native/file'

import { storagePaths } from './storagePaths'

export function useUserTmpUploader(userId: string) {
  const [progress, setProgress] = useState(0)
  const [uploading, setUploading] = useState(false)

  return {
    /**
     * upload a file to user's tmp dir
     */
    async upload(
      file?: File | Blob | PickFile,
      base64?: boolean,
      hasExt?: boolean
    ) {
      setUploading(true)
      const ext = hasExt ? `.${getExtFile(file)}` : ''
      const filePath = path.join(
        storagePaths.userTmpDir.replace(':userId', userId),
        String(Math.round(Math.random() * 1000000000)) + ext
      )

      const storage = getStorage()
      const storageRef = ref(storage, filePath)

      if (base64) {
        const snapshot = await uploadString(storageRef, file?.data, 'base64', {
          contentType: file?.mimeType,
        })
        setProgress(0)
        return {
          tmpPath: snapshot.ref.fullPath,
          fileUrl: await getDownloadURL(snapshot.ref),
        }
      }

      const task = uploadBytesResumable(storageRef, file, {
        contentType: mime.getType(file?.type),
      })

      task.on('state_changed', snap => {
        const progress = (snap.bytesTransferred / snap.totalBytes) * 100
        setProgress(Math.min(progress, 100))
      })

      await task
        .then(() => setProgress(0))
        .catch(e => {
          throw e
        })
        .finally(() => setUploading(false))

      return {
        tmpPath: task.snapshot.ref.fullPath,
        fileUrl: await getDownloadURL(task.snapshot.ref),
      }
    },
    progress,
    uploading,
  }
}

function getExtFile(file: File | File.PickFile): string {
  // for image file
  if ('type' in file) {
    return file.type === 'jpeg' ? 'jpg' : file.type
  }
  // for other file (video, pdf, audio)
  return mime.getExtension(file.mimeType) || ''
}
